import { gql } from "@apollo/client";

export const GET_BONUS_AMOUNTS = gql`
query getReferralEarningAmount {
  earning_configuration(where: {referral_type: {_eq: quick_cut}}) {
    eg_id
    referral_amount
    referral_type
  }
}
`;

export const UPDATE_BONUS_AMOUNTS = gql`
mutation updateReferralEarning ($userReferralBonus: float8!, $affiliateReferralBonus: float8!, $quickCutReferralBonus: float8!) {
  update_earning_configuration_many(updates: [{where:{referral_type:{_eq:user}},_set:{referral_amount:$userReferralBonus}},{where:{referral_type:{_eq:affiliate}},_set:{referral_amount:$affiliateReferralBonus}},{where:{referral_type:{_eq:quick_cut}},_set:{referral_amount:$quickCutReferralBonus}}]) {
    affected_rows
    returning {
      referral_amount
      referral_type
      eg_id
    }
  }
}
`;

export const UPDATE_QUICK_CUT_AMOUNT = gql`
mutation updateQuickCutAmount ($quickCutAmount: float8!) {
  update_earning_configuration(where: {referral_type:{_eq:quick_cut}}, _set: {referral_amount:$quickCutAmount}) {
    affected_rows
    returning {
      referral_amount
      referral_type
      eg_id
    }
  }
}
`;

export const GET_SUPER_USER_BY_UID = gql`
query getSuperUserByUId($u_id:uuid!){
  super_user(where: {u_id: {_eq: $u_id }, su_is_active: {_eq: true}, su_deleted_at: {_is_null: true}}){
    su_id
    u_id
    su_first_name
    su_last_name
    su_email_id
    su_is_active
    percentage
  }
}` 
